import styled from "styled-components";

// Contenedor de los selectores (react-dropdown-select) de las pantallas de competiciones
export const CompetitionSelectCont = styled.div`
    padding-top: 8px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    max-width: 360px;
    margin: 0 4px;
    label
    {
        margin-bottom: 5px;
    }
    div
    {
        width: 100%;
    }
    /* Anulamos el width: 100% en los div internos del selector para que el texto no se parta */
    .react-dropdown-select-content
    {
        width: auto;
        flex: 1;
        min-width: 0;
        flex-wrap: nowrap;
        overflow: hidden;
    }
    .react-dropdown-select-content > span
    {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .react-dropdown-select-dropdown-handle
    {
        width: auto;
    }
`;
